import { useEffect, useState } from "react";
import { Link } from "wouter";
import { openNewYearBooking } from "@/components/booking-modal";
import { isCampaignActive, NY_PATH, NY_POSTER, NY_PHONE, NY_PHONE_HREF } from "./campaign";

/** Homepage campaign block. Mounted only after hydration to avoid SSR mismatch on the date gate. */
export function NewYearAnnouncement() {
  const [show, setShow] = useState(false);
  useEffect(() => setShow(isCampaignActive()), []);
  useEffect(() => {
    if (show && window.location.hash === "#new-year-2027") {
      document.getElementById("new-year-2027")?.scrollIntoView();
    }
  }, [show]);
  if (!show) return null;

  return (
    <section
      id="new-year-2027"
      aria-labelledby="ny-home-title"
      className="ny-stage relative overflow-hidden border-y border-[hsl(var(--ny-gold)/0.35)]"
      data-testid="section-new-year"
    >
      <div className="ny-curtain" aria-hidden="true" />
      <div className="relative z-10 container mx-auto px-6 md:px-14 py-20 md:py-28 grid md:grid-cols-[1.05fr_1fr] gap-12 md:gap-16 items-center">
        <div className="ny-reveal">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[hsl(var(--ny-gold))]" />
            <span className="text-[9px] tracking-[0.4em] uppercase text-[hsl(var(--ny-gold))]">31 декабря 2026 · начало 22:00</span>
          </div>
          <h2 id="ny-home-title" className="font-serif font-light text-white leading-[1.02] text-[clamp(34px,5vw,72px)] mb-6">
            Императорский<br /><span className="italic text-[hsl(var(--ny-gold))]">Новый год</span>
          </h2>
          <p className="text-white/70 leading-[1.9] max-w-md mb-4">
            В новогоднюю ночь ресторан превращается в императорский дворец над крышами Петербурга:
            церемониальный приём, бал и щедрый праздничный стол. Встречаем 2027 вместе.
          </p>
          <p className="text-white/45 text-xs tracking-wide mb-10">Императорское меню включено в стоимость билета. Стоимость и наличие мест уточняйте при бронировании.</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button onClick={() => openNewYearBooking("home_announcement")} data-testid="button-ny-book-home" className="ny-btn-gold">Забронировать стол</button>
            <Link href={NY_PATH} data-testid="link-ny-details" className="ny-btn-ghost">Программа и меню</Link>
          </div>
          <a href={NY_PHONE_HREF} className="inline-block mt-6 text-[11px] tracking-[0.2em] text-white/50 hover:text-[hsl(var(--ny-gold))] transition-colors">
            или по телефону {NY_PHONE}
          </a>
        </div>
        <Link href={NY_PATH} aria-label="Подробнее об Императорском Новом годе" className="ny-poster-frame block mx-auto w-full max-w-[440px]">
          <img src={NY_POSTER} alt="Афиша: Императорский Новый год 2027 в ресторане Паруса на крыше" loading="lazy" decoding="async" className="w-full h-auto object-contain block" />
        </Link>
      </div>
    </section>
  );
}
